import React from "react";
import SEO from "../data/seo";
import INFO from "../data/user";
import NavBar from "../components/common/navBar";
import { Helmet } from "react-helmet";
import Logo from "../components/common/logo";
import ThemeToggle from "../components/common/themeToggle";

const PublicSpeaking = () => {
	const currentSEO = SEO.find((item) => item.page === "publicspeaking");

	return (
		<React.Fragment>
			<Helmet>
				<title>{`Public Speaking — ${INFO.main.title}`}</title>
				<meta name="description" content={currentSEO.description} />
				<meta
					name="keywords"
					content={currentSEO.keywords.join(", ")}
				/>
			</Helmet>

			<div className="page-content">
				<NavBar active="publicspeaking" />
				<div className="content-wrapper">
					<div className="articles-logo-container">
						<div className="articles-logo">
							<Logo width={46} />
						</div>
					</div>
					<div className="themebuttom-container">
						<div className="theme-button-wrapper">
							<ThemeToggle />
						</div>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default PublicSpeaking;
